import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Youtube,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (sectionId: string) => {
    navigate("/", { replace: true });
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img
                src="favicon-32x32.png"
                alt="Manomay Homeopathy and Counselling Center Logo"
              />
              <span className="ml-2 text-xl font-semibold">
                Manomay Homeopathy and Counselling Center
              </span>
            </div>
            <p className="text-gray-400">
              Providing natural healing solutions through professional
              homeopathic care.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleNavigation("home")}
                  className="text-gray-400 hover:text-manomay-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation("about")}
                  className="text-gray-400 hover:text-manomay-300"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation("treatments")}
                  className="text-gray-400 hover:text-manomay-300"
                >
                  Treatments
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation("testimonials")}
                  className="text-gray-400 hover:text-manomay-300"
                >
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-manomay-300 mr-2" />
                <span className="text-gray-400">+91-8169782983</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-manomay-300 mr-2" />
                <span className="text-gray-400">
                  manomayhomeopathy@gmail.com
                </span>
              </li>
              <li className="flex items-center">
                <MapPin className="h-15 w-16 text-manomay-300 mr-2" />
                <span className="text-gray-400">
                  Office No. 515, 5th Floor, Fortuna Business Center, Shivar Chowk, 
                  Above Hotel Radha Krishna, Opposite McDonald's, Pimple Saudagar,
                  Pimpri-Chinchwad, Pune, Maharashtra 411027, India
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                aria-label="Facebook"
                href="https://facebook.com/manomay.homeo/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-manomay-300"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                aria-label="Youtube"
                href="https://youtube.com/channel/UC1yNCpQ0hAe9tuKUgGTNUYg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-manomay-300"
              >
                <Youtube className="h-6 w-6" />
              </a>
              <a
                aria-label="Instagram"
                href="https://instagram.com/manomay.homeo/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-manomay-300"
              >
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Manomay Homeopathy and Counselling
            Center. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
